import React from "react";
import Routes from "routing/Routes";
import { ReplaySearchButtonComponent } from "views/components/widgets/ReplaySearchButton";
import useParams from "routing/useParams";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
const LinkToReplaySearch = ({ isEvent = false, id = void 0, onClick = void 0, isMenuitem = false }) => {
  const { definitionId } = useParams();
  const searchLink = isEvent ? Routes.ALERTS.replay_search(id) : Routes.ALERTS.DEFINITIONS.replay_search(id || definitionId);
  return /* @__PURE__ */ React.createElement(
    ReplaySearchButtonComponent,
    {
      searchLink,
      onClick,
      component: isMenuitem ? MenuItem : void 0
    },
    "Replay search"
  );
};
export default LinkToReplaySearch;
